export const NEW_GAME   = "NEW_GAME"
export const SET_KEY   = "SET_KEY"
export const TIMER_TICK   = "TIMER_TICK"
export const SERVER_REQUEST   = "SERVER_REQUEST"
export const SERVER_SUCCESS   = "SERVER_SUCCESS"
export const SERVER_FAILTURE  = "SERVER_FAILTURE"